import { defineMessages } from 'react-intl';

export default defineMessages({
    noCoverage: {
        id: 'quoteandbind.bop.directives.bop-building-directive.No Coverages',
        defaultMessage: 'No Coverages'
    },
    noneSelected: {
        id: 'policycommon.directives.coverages.select.None Selected',
        defaultMessage: 'None Selected'
    },
    selectedValue: {
        id: 'policycommon.The value must be between',
        defaultMessage: 'The value must be between {minValue} and {maxValue}'
    },
    minValue: {
        id: 'policycommon.The minimum allowed value is',
        defaultMessage: 'The minimum allowed value is {minValue}'
    },
    maxValue: {
        id: 'policycommon.The maximum allowed value is',
        defaultMessage: 'The maximum allowed value is {maxValue}'
    },
    updatingSelection: {
        id: 'policycommon.directives.coverages.Updating selection...',
        defaultMessage: 'Updating selection...'
    }
});
